export class FmWrapper {
    private isFileMaker: boolean;
    constructor(overlayId: string) {
        this.isFileMaker = this.detectFileMaker();
        const overlay = document.getElementById(overlayId);
        if (overlay) {
            overlay.innerText = this.isFileMaker
                ? "Running inside FileMaker."
                : "Not running inside FileMaker.";
        }

        this.fmProtect();
    }

    detectFileMaker() {
        if (typeof window.FileMaker == "undefined") return false;
        return typeof window.FileMaker.PerformScriptWithOption == "function";
    }

    executeSync<T>(payload: T, functionName: string | null) {
        if (!functionName) {
            functionName = "fmx-player-sync";
        }
        const stringPayload = JSON.stringify(payload);
        if (!this.isFileMaker) {
            //   alert("execute sync " + functionName);
            // alert(stringPayload);
        } else {
            window.FileMaker?.PerformScript(functionName, stringPayload);
        }
    }

    fmProtect() {
        document.addEventListener("contextmenu", (event) => {
            event.preventDefault();
        });

        document.addEventListener("keydown", (event) => {
            if (event.ctrlKey && event.key === "u") {
                event.preventDefault();
            }
            if (event.ctrlKey && event.shiftKey && event.key === "I") {
                event.preventDefault();
            }
            if (event.key === "F12") {
                event.preventDefault();
            }
        });

        document.addEventListener("selectstart", (event) => {
            event.preventDefault();
        });

        document.addEventListener("dragstart", (event) => {
            event.preventDefault();
        });
    }

    public onPlayerReady() {
        this.executeSync(null, "fmx-player-ready");
    }
}

export const fm = new FmWrapper("env-overlay");
